import MModal from './Modal.vue';

export default MModal;
